// Pure content fingerprint arithmetic, available in the module runtime as well as browser/Node.
const utf8 = (text: string) => new TextEncoder().encode(text);

/** FNV-1a 64-bit over UTF-8, folded to 32 bits: the content fingerprint's hash. */
export function contentHash(text: string): number {
  const bytes = utf8(text);
  // 64-bit arithmetic in four 16-bit limbs (no BigInt in the loop). Prime 1099511628211 = 0x0000_0100_0000_01b3.
  let h0 = 0x2325, h1 = 0x8422, h2 = 0x9ce4, h3 = 0xcbf2; // offset basis 0xcbf29ce484222325
  for (let i = 0; i < bytes.length; i++) {
    h0 ^= bytes[i];
    // h * 0x1b3 + (h << 40)
    const t0 = h0 * 0x1b3, t1 = h1 * 0x1b3, t2 = h2 * 0x1b3, t3 = h3 * 0x1b3;
    const r0 = t0;
    const r1 = t1 + (r0 >>> 16);
    const r2 = t2 + (r1 >>> 16) + (h0 << 8);
    const r3 = t3 + (r2 >>> 16) + (h1 << 8);
    h0 = r0 & 0xffff; h1 = r1 & 0xffff; h2 = r2 & 0xffff; h3 = r3 & 0xffff;
  }
  const lo = ((h1 << 16) | h0) >>> 0, hi = ((h3 << 16) | h2) >>> 0;
  return (lo ^ hi) >>> 0;
}

